import Goods from '../../pages/goods'

const goodsRoute = [
  {
    path: '/goods',
    name: 'goods',
    component: Goods
  }
]

export default goodsRoute



// WEBPACK FOOTER //
// ./src/router/goods/index.js